import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BaseBadge = styled.div`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#FF0000')};
  width: auto;
  height: 24px;
  border-radius: 16px;
  padding: 2px 7px;
  display: inline-flex;
  gap: 5px;
  align-items: center;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: ${(props) => (props.color ? props.color : '#FF0000')};
  margin-left: ${(props) => (props.left ? props.left : '0px')};

  .dot {
    background-color: ${(props) => (props.color ? props.color : '#FF0000')};
    width: 6px;
    height: 6px;
    border-radius: 100%;
    box-sizing: border-box;
  }
`;

export const Badge = ({ children, ...props }) => {
  return (
    <BaseBadge {...props}>
      <div className="dot" />
      {children}
    </BaseBadge>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
};
